var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeclined = function SvgDeclined(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solid/16*16/informative/declined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1204 7.99967C15.1204 11.6816 12.1357 14.6663 8.45378 14.6663C4.77188 14.6663 1.78711 11.6816 1.78711 7.99967C1.78711 4.31778 4.77188 1.33301 8.45378 1.33301C12.1357 1.33301 15.1204 4.31778 15.1204 7.99967ZM10.693 10.2388C10.4977 10.4341 10.1811 10.4341 9.98585 10.2388L8.45378 8.70674L6.92171 10.2388C6.72645 10.4341 6.40986 10.4341 6.2146 10.2388C6.01934 10.0436 6.01934 9.72697 6.2146 9.53171L7.74668 7.99963L6.21461 6.46757C6.01935 6.27231 6.01935 5.95573 6.21461 5.76046C6.40987 5.5652 6.72646 5.5652 6.92172 5.76046L8.45378 7.29253L9.98584 5.76047C10.1811 5.56521 10.4977 5.56521 10.6929 5.76047C10.8882 5.95573 10.8882 6.27232 10.6929 6.46758L9.16089 7.99963L10.693 9.5317C10.8882 9.72696 10.8882 10.0435 10.693 10.2388Z",
    fill: "#CF1322"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeclined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "declined.3e3f0db9838fad8e8d05cf1ebc5000ab.svg";